import styled from 'styled-components';
import { COLORS } from '../../../styles/variables';

export const OfferTypeListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: Audi Type;
`;

export const CheckBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Description = styled.div`
  padding-top: 12px;
  letter-spacing: 0.002px;
  line-height: 20px;
  font-size: 12px;
  color: ${COLORS.grey60};
  padding-left: 32px;
`;
